import { useCallback, useEffect, useState } from "react";
import { baseAxios } from "../utils/config";

const GENERIC_ERROR = "Could not load organizations";

/**
 * Every organization, for the super admin's organization picker.
 * @returns {{ organizations: Array, loading: boolean, error: string|null, reload: Function }}
 */
export function useOrganizationList() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await baseAxios.get("/organization/list");
        if (isMounted) {
          setOrganizations(response.data?.organizations || []);
        }
      } catch (err) {
        if (isMounted) {
          setOrganizations([]);
          setError(err?.data?.message || GENERIC_ERROR);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [attempt]);

  const reload = useCallback(() => setAttempt((n) => n + 1), []);

  return { organizations, loading, error, reload };
}
